import React from 'react';
import { Routes, Route } from 'react-router-dom';
import ConsumptionsPage from '@pages/consumptions/ConsumptionsPage';
import ConsumptionCreatePage from '@pages/consumptions/ConsumptionCreatePage';
import ConsumptionEditPage from '@pages/consumptions/ConsumptionEditPage';
import ConsumptionViewPage from '@pages/consumptions/ConsumptionViewPage';

export const ConsumptionsRoutes = () => {
    return (
        <Routes>
            <Route path="/" element={<ConsumptionsPage />} />
            <Route path="/create" element={<ConsumptionCreatePage />} />
            <Route path="/:id" element={<ConsumptionViewPage />} />
            <Route path="/:id/edit" element={<ConsumptionEditPage />} />
        </Routes>
    );
};

export default ConsumptionsRoutes;
